import { ExternalLink } from "lucide-react";

const SPOTIFY_FEATURED_ALBUM_URL = "https://open.spotify.com/album/6Y2HN2AIv4TqG2u31dxDVR";
const SPOTIFY_FEATURED_ALBUM_EMBED_SRC =
  "https://open.spotify.com/embed/album/6Y2HN2AIv4TqG2u31dxDVR?utm_source=generator&si=22a58d6425994d83";
const SPOTIFY_BFH_URL = "https://open.spotify.com/album/0y62RTIkSb06Dxn7RAXvsW";
const SPOTIFY_BFH_EMBED_SRC =
  "https://open.spotify.com/embed/album/0y62RTIkSb06Dxn7RAXvsW?utm_source=generator&si=1fafe8d7747a4008";

export const UntitledEmbed = () => (
  <div className="relative mt-10 overflow-hidden rounded-3xl border border-white/10 bg-[#141419]" data-testid="catalog-embed-band">
    <div className="space-y-3 p-3 sm:p-4">
      <iframe
        title="Featured album — PRODRUSHI on Spotify"
        data-testid="catalog-spotify-featured-album"
        style={{ borderRadius: 12 }}
        src={SPOTIFY_FEATURED_ALBUM_EMBED_SRC}
        width="100%"
        height="152"
        frameBorder="0"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />
      <iframe
        title="BELLS FROM HELL — the album, on Spotify"
        data-testid="catalog-spotify-album-player"
        style={{ borderRadius: 12 }}
        src={SPOTIFY_BFH_EMBED_SRC}
        width="100%"
        height="352"
        frameBorder="0"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />
    </div>
    <div className="flex items-center justify-between gap-4 border-t border-white/10 px-5 py-3">
      <p className="font-mono text-[11px] uppercase tracking-widest text-emerald-200">
        Featured album · BELLS FROM HELL — the album
      </p>
      <a
        href={SPOTIFY_FEATURED_ALBUM_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="catalog-spotify-open-link"
        className="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-wider text-zinc-400 transition-colors hover:text-emerald-200"
      >
        Follow on Spotify <ExternalLink size={11} />
      </a>
    </div>
  </div>
);
